import { VirtualScrollModule } from './virtual-scroll.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PublicGalleryComponent } from './shared/components/public-gallery/public-gallery.component';
import { ErrorHandler, Injectable, NgModule, importProvidersFrom, isDevMode } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "src/environments/environment";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { provideAuth, getAuth } from "@angular/fire/auth";
// Firestore and Storage were provided here but never used - no collection()/doc()/
// getDownloadURL() call exists anywhere in src/app. Providing them pulled both SDKs
// into vendor.js on every page load, ahead of the LCP image. Removed.
import { SharedModule } from "./shared/shared.module";
import { AngularFireModule } from "@angular/fire/compat";
import { ViewEventComponent } from "./home/component/view-event/view-event.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { AddFromGalleryPopupComponent } from './add-from-gallery-popup/add-from-gallery-popup.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ConfirmationModalComponent } from './shared/confirmation-modal/confirmation-modal.component';
import { UploadSelfieComponent } from './upload-selfie/upload-selfie.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import * as Sentry from "@sentry/angular-ivy";
import { Router, RouterModule } from '@angular/router';
import { ImagePreviewDialogComponent } from './event-gallery/image-preview-dialog/image-preview-dialog.component';
import { CreateEventComponent } from './create-event/create-event.component';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule, NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { QrInviteComponent } from './create-event/qr-invite/qr-invite.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SelfieLandingPageComponent } from './selfie-landing-page/selfie-landing-page.component';
import { PromoVideoComponent } from './promo-video/promo-video.component';
import { OpenGalleryComponent } from './open-gallery/open-gallery.component';

import { EventSettingsComponent } from './event-settings/event-settings.component';
import { EventSettingsV2Component } from './event-settings-v2/event-settings-v2.component';
import { MatChipInput, MatChipsModule } from '@angular/material/chips';
import { InfoModalComponent } from './event-settings/info-modal/info-modal.component';
import { MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { CoverImageComponent } from './cover-image/cover-image.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminMenuComponent } from './admin-menu/admin-menu.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { PhotowallEventlistComponent } from './photo-wall/photowall-eventlist/photowall-eventlist.component';
import { PhotowallConfigurationComponent } from './photo-wall/photowall-configuration/photowall-configuration.component';
import { PhotowallRoutes } from './photo-wall/photowall-configuration/photowall.route.module';
import { PhotowallModule } from './photo-wall/photowall-configuration/photowall.module';
import { EditPastEventComponent } from './edit-past-event/edit-past-event.component';
import { SendMessageComponent } from './send-message/send-message.component';
import { QrRedirectComponent } from './qr-redirect/qr-redirect.component';
import { SelfieRedirectComponent } from './selfie-redirect/selfie-redirect.component';
import { SelfieUpdatedPopupComponent } from './selfie-updated-popup/selfie-updated-popup.component';
import { ToastComponent } from './toast/toast.component';
import { UploadBannerComponent } from './upload-banner/upload-banner.component';
import { CreateEventsComponent } from './create-events/create-events.component';
import { CreateEventSheetComponent } from './create-event-sheet/create-event-sheet.component';
import { InviteUsersComponent } from './create-events/invite-users/invite-users.component';
//import { WebQrComponent } from './photo-wall/web-qr/web-qr.component';
import { ShareModalComponent } from './share-popup/share-popup.component';
//import { NewEventDetailsComponent } from './new-event-details/new-event-details.component';
import { EventConfigurationsComponent } from './event-configurations/event-configurations.component';
import { MyPhotosConfigurationComponent } from './my-photos-configuration/my-photos-configuration.component';
import { NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { LuxonNgxDateAdapter, LUXON_NGX_DATETIME_FORMATS } from './utils/luxon-date-adapter';
import { TopBarComponent } from './top-bar/top-bar.component';
import { InviteDialogComponent } from './invite-dialog/invite-dialog.component';
import { InviteCardComponent } from './invite-card/invite-card.component';
import { CoverImageCropComponent } from './cover-image-crop/cover-image-crop.component';
import { RsvpDialogComponent } from './rsvp-dialog/rsvp-dialog.component';
import { UploadSelfieMyPhotosComponent } from './upload-selfie-myphotos/upload-selfie-myphotos.component';
import { PaymentTestComponent } from './payment-test/payment-test.component';

import { InvitationCardDesignerComponent } from './invitation-card-designer/invitation-card-designer.component';
import { FreePlanUpgradeCardComponent } from './free-plan-upgrade-card/free-plan-upgrade-card.component';
import { BuyEventDialogComponent } from './buy-event-dialog/buy-event-dialog.component';
import { ExtendEventDialogComponent } from './extend-event-dialog/extend-event-dialog.component';
import { PaymentLogsDialogComponent } from './payment-logs-dialog/payment-logs-dialog.component';

import { EventAlbumComponent } from './event-album/event-album.component';
import { BrandingProgressDialogComponent } from './add-branding/branding-progress-dialog/branding-progress-dialog.component';
import { UpdateEventComponent } from './update-event/update-event.component';

import { GuestLoginPopupComponent } from './guest-login-popup/guest-login-popup.component';
import { DemoLoginPopupComponent } from './demo-login-popup/demo-login-popup.component';
import { TimezonePickerComponent } from './timezone-picker/timezone-picker.component';
import { DemoEventComponent } from './demo-event/demo-event.component';
import { DemoLandingComponent } from './demo-landing/demo-landing.component';
import { DemoDirectGalleryComponent } from './demo-direct-gallery/demo-direct-gallery.component';
import { MyEventsComponent } from './myevents/myevents.component';

@Injectable()


@NgModule({
  declarations: [
    AppComponent,
    EventAlbumComponent,
    AddFromGalleryPopupComponent,
    PublicGalleryComponent,
    ViewEventComponent,
    // ConfirmationModalComponent,
    UploadSelfieComponent,
    UploadSelfieMyPhotosComponent,
    ImagePreviewDialogComponent,
    CreateEventComponent,
    QrInviteComponent,
    PromoVideoComponent,
    SelfieLandingPageComponent,
    InfoModalComponent,
    OpenGalleryComponent,
    EventSettingsComponent,
    EventSettingsV2Component,
    CoverImageComponent,
    AdminMenuComponent,
    PhotowallEventlistComponent,
    PhotowallConfigurationComponent,
    EditPastEventComponent,
    SendMessageComponent,
    QrRedirectComponent,
    SelfieRedirectComponent,
    SelfieUpdatedPopupComponent,
    ToastComponent,
    UploadBannerComponent,
    CreateEventsComponent,
    CreateEventSheetComponent,
    InviteUsersComponent,
    ShareModalComponent,
    EventConfigurationsComponent,
    UpdateEventComponent,
    MyPhotosConfigurationComponent,
    TopBarComponent,
    InviteDialogComponent,
    InviteCardComponent,
    InvitationCardDesignerComponent,
    //CoverImageCropComponent
    RsvpDialogComponent,
    PaymentTestComponent,
    FreePlanUpgradeCardComponent,
    BuyEventDialogComponent,
    ExtendEventDialogComponent,
    PaymentLogsDialogComponent,
    //ConfirmationModalComponent,
    BrandingProgressDialogComponent,
    GuestLoginPopupComponent,
    DemoLoginPopupComponent
    ,    //EventAlbumComponent
    UpdateEventComponent,
    TimezonePickerComponent,
    DemoEventComponent,
    DemoLandingComponent,
    DemoDirectGalleryComponent,
    MyEventsComponent,
  ],
  // VirtualScrollModule, // Removed duplicate entry from declarations
  imports: [
    // 
    BrowserModule,
    ScrollingModule,
    SharedModule,
    NgIdleKeepaliveModule.forRoot(),
    AppRoutingModule,
    PhotowallModule,
    PhotowallRoutes,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    NgxSkeletonLoaderModule,
    MatDialogModule,
    MatTableModule,
    MatTooltipModule,
    MatRadioModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,
    MatSortModule,
    MatButtonToggleModule,
    MatMenuModule,
    NgxMatColorPickerModule,
    MatPaginatorModule,
    MatToolbarModule, MatAutocompleteModule,
    ImageCropperModule,
    //ConfirmationModalComponent,
    CoverImageCropComponent,
    NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule, MatDatepickerModule,

    // Registration is disabled here on purpose - main.ts already registers the very
    // same custom-sw.js, and does it better: it waits for 'load' + 1s and skips iOS
    // Safari, and it wires up the 'api-updated' message listener that ApiCacheService
    // depends on. This module was registering it a SECOND time with
    // registerImmediately, which fired mid-bootstrap and competed with the LCP image
    // for bandwidth and main thread. Nothing consumes SwUpdate/SwPush (every
    // reference in the codebase is commented out); updates go through
    // AppComponent.checkForUpdate()'s version.json poll instead. Kept registered-but-
    // disabled so the SwUpdate provider still resolves for anything injecting it.
    ServiceWorkerModule.register("custom-sw.js", {
      enabled: false
    }),
    //provideFirebaseApp(() => initializeApp(environment.firebase)),
    AngularFireModule.initializeApp(environment.firebase),
    provideAuth(() => getAuth()),
  ],
  providers: [{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      showDialog: false,
    })
  },
  provideAnimations(),
  { provide: NgxMatDateAdapter, useClass: LuxonNgxDateAdapter },
  { provide: NGX_MAT_DATE_FORMATS, useValue: LUXON_NGX_DATETIME_FORMATS },
  { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },

  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  { provide: MAT_DIALOG_DATA, useValue: {} },
  { provide: MatDialogRef, useValue: {} }],
  bootstrap: [AppComponent],
})

export class AppModule {
  constructor(trace: Sentry.TraceService) { }


}
